/*
    模块组件
    ChenYN

    说明
    空状态

    版本
    1.0

    传参
        title Sting : 非必填 文本
    依赖
    /style/2019/h5/css/common.css
    vue.js
    vant

    案例
    <demo></demo>
*/
<template>
    <div class="empty_wrap">
        <Empty v-if="platform != 'chuangyue'" class="custom_image alin" :image="empryIcon" :description="title" />
        <Empty v-else class="custom_image alin" :image="empryIcon_chuangyue" :description="title" />
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import { Empty } from "vant"
import router from "@/router"
import empryIcon from "@/assets/images/common/icon_empty2.png"
import empryIcon_chuangyue from "@/assets/images/common/icon_empty2_chuangyue.png"

export default defineComponent({
    name: 'EmptyStatus',
    components: { Empty },
    props: {
        title: {
            type: String,
            default: '空空如也，暂无消息哦'
        }
    },
    setup(props) {
        const state = reactive({
            empryIcon: empryIcon,
            empryIcon_chuangyue: empryIcon_chuangyue,
            platform: window.Config.platform
        });
        const data = reactive({});
        const methods = {
            back: () => route.back(),
            goState: (o) => router.push(o),
        }; //需要对外暴露的方法

        onMounted(() => {
        //   console.log("组件渲染");
        });
        return {
            ...toRefs(state),
            ...toRefs(data),
            ...methods
        };
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@import "./EmptyStatus.less";
</style>
